import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {connect} from 'react-redux';
import {replacePlaceholders} from '../../../utilities/StringHelpers/TitleHelpers';
import {FLOW_STEPS} from './Conatant';
import {setCurrentStep, clearHistory, GetOrganizationFamilyData} from './OrganizationEmployeeSlice';
import { AssignBenefitsToOrgFamilyMember  } from './OrganizationEmployeeSlice';
import buttonDownload from '../FundialPage/Shared/Buttons/ButtonDownload/ButtonDownload';

const GeneralMessage = ({messageData, popupActions, data , setShowPopup}) => {
  const {icon, title, secondTitle, subTitle, buttonList, isPopup, subTitleCondition, params} = messageData;


  const handleButtonClick = (button) => {
    if(typeof button.click === 'function'){
      button.click();
      }else{
        if(button.click){
           popupActions(button.click);
        }
      }
      setShowPopup(false);
    }
  

  return (
      <div className='general-message-page' >
          <Image src={icon} />
          <p className='title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, data, isMobile)}} />
          {secondTitle && (
            <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, data, isMobile)}} />
          )}
          {subTitle && (!subTitleCondition  || subTitleCondition(data) )&& (
            <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(subTitle, data, isMobile)}} />
          )}
          <div className='buttons-wrapper'> 
            {buttonList.map((button, index) => (
              <div className='continue-button'>
                  <BtnSubmit className={button.color} key={index} text={button.text} onclick={() => handleButtonClick(button)} />
              </div>
            ))}
        </div>
      </div>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {setCurrentStep, AssignBenefitsToOrgFamilyMember, clearHistory ,GetOrganizationFamilyData};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
